import { gql } from 'graphql-request';

export const UPDATE_POA_USER = gql`
  mutation CorePOAUsers($userId: ID!, $userType: String!, $data: JSONObject!) {
    corePOAUsers {
      updateData(userId: $userId, userType: $userType, data: $data)
    }
  }
`;
